import { SETTINGS_PAGE_UNLOADED } from './types'

export const unload = () => ({
  type: SETTINGS_PAGE_UNLOADED
})
